import React from 'react';
var LimitIcon = function () {
    return (React.createElement("svg", { width: "13", height: "13", viewBox: "0 0 14 14", fill: "none" },
        React.createElement("path", { d: "M2 4h10M2 7h7M2 10h5", stroke: "#6C63D8", strokeWidth: "1.2", strokeLinecap: "round" }),
        React.createElement("circle", { cx: "11", cy: "10", r: "2", stroke: "#7F35B2", strokeWidth: "1.2" })));
};
export default LimitIcon;
